---
en:
  production_simulation_plan:
    axis_names:
      energy: Energy
      inflow_energy: Inflow Energy
      price: Price
      reservoir_energy: Reservoir Energy
      volume: Volume (MWh)
    chart_names:
      actual_market_price: Actual Market price
      actual_production: Actual production
      estimated_inflow: Estimated inflow
      estimated_price: Estimated price
      estimated_reservoir_volume: Estimated reservoir volume
      past_planned_production: Past planned production
      planned_production: Planned production
